import React from "react";
import img1 from "../../../Assets/ISO Certification/img1.png";
import img2 from "../../../Assets/ISO Certification/img2.png";
import img3 from "../../../Assets/ISO Certification/img3.png";

const ISOSpecifications = () => {
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 p-10">
        {/* right side content  */}
        <div className="w-full text-[#032303] font-medium sm:text-3xl md:font-medium text-md lg:text-3xl xl:text-4xl">
          <h1 className="mb-3">
            <span className="border-b-4 border-[#249742]"> ISO 500</span>
            01:2011 Specifications :
          </h1>

          <div className="py-4 lg:py-8 space-y-2">
            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              Measurement, documentation and reporting, design and acquisition
              practices for equipment, systems, processes and personnel that
              contribute to energy performance .
            </p>

            <ol className="list-decimal ml-5 text-xs md:text-lg py-4 text-[#4D4D4D]">
              <li>Monitor all variables affecting energy performance.</li>
              <li className="py-2">
                ISO 50001:2011 is applicable to any organization wishing to
                ensure that it conforms to its stated energy policy and wishing
                to demonstrate this to others, such conformity being confirmed
                either by means of self-evaluation and self-declaration of
                conformity, or by certification of the energy management system
                by an external organization.
              </li>
            </ol>
          </div>
        </div>

        {/* left side images  */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex flex-col items-end gap-4 justify-end w-full">
            <div className="w-full lg:w-auto">
              {" "}
              <img src={img1} alt="" className="rounded-lg w-full lg:w-auto" />
            </div>
            <div className="w-full lg:w-auto">
              {" "}
              <img src={img2} alt="" className="rounded-lg w-full lg:w-auto" />
            </div>
          </div>
          <div className="h-full">
            <img src={img3} alt="" className="rounded-lg h-full" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ISOSpecifications;
